module.exports = ".content-snack-bar {\n  background-color: #F0E72D;\n  color: #000; }\n\n.text-close {\n  text-decoration: underline;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/mensaje-snack-bar/mensaje-snack-bar.component.scss
// module id = ./src/app/components/shared/mensaje-snack-bar/mensaje-snack-bar.component.scss
// module chunks = main